import { Injectable } from '@angular/core';
import { HttpNewService } from './application/http-new.service';
import { Observable } from 'rxjs';
import { IHttpRequest } from './application/IHttpRes.interfaces';
import { IResponseEsiaData } from '../interfaces/patient.interfaces';

@Injectable({
    providedIn: 'root',
})
export class EsiaService {
    public constructor(private httpNew: HttpNewService) {}

    /* Получение URLl ГосУслуг для авторизации на ГосУслугах */
    public getInfo$(): Observable<string> {
            return this.httpNew.get<string>('/user/esia/info', null)
    }

    /* Получение информации по коду с ГосУслуг */
    public getInfoState$(state: string): Observable<IResponseEsiaData> {
            return this.httpNew.get<IResponseEsiaData>('/user/esia/authorization?state=' + state, null);
    }
}
